<div class="grid__cell grid__cell--widget grid__celll--widget-menu grid__cell--full">
  <div class="widget__wrap">
    <div class="widget"
         id="menu-widget"
         style="position: relative;">

      <h2 class="widget__header">
        <span class="widget__header__title">
          <i class="widget__header__icon ico-angle-down"></i> Menu</span>
      </h2>

      <div class="widget__content"
           id="nav-admin"
           *ngIf="isInitialized">

        <nav class="langtabs__nav">
          <span *ngFor="let lang of langs; let i = index">
            <a [ngClass]="{'langtabs__link--active': i === activeLangIndex}"
               class="langtabs__link langtabs__link--inverted"
               (click)="switchTab(i)">{{ lang }}</a>
          </span>
        </nav>
        <div *ngFor="let lang of langs; let i = index">
          <div [ngClass]="{'langtabs__content--active': i === activeLangIndex}"
               class="langtabs__content langtabs__content--inverted"
               id="menu-langtab-{{ lang }}">

            <div class="grid navadmin">

              <div class="grid__cell grid__cell--nav">
                <h3 class="widget__heading">Položky možné využít v menu</h3>
                <div class="navadmin__list-wrap">
                  <tree-root [nodes]="treeAvailableNodes[lang]"
                             (moveNode)="onMoveNode($event, true)"
                             [options]="treeAvailableOptions">
                    <ng-template #treeNodeTemplate
                                 let-node="node"
                                 let-index="index">
                      <i
                         [ngClass]="{'ico-pages': node.data.itemType === 'page', 'ico-box': node.data.itemType === 'category', 'ico-link': node.data.itemType === 'custom', 'ico-articles': node.data.itemType === 'blog', 'ico-real-estate': node.data.itemType === 'developer-projects', 'ico-homepage': node.data.itemType === 'real-estate'}"></i>
                      <span>{{ node.data.name }}</span>
                      <a *ngIf="node.data.itemType === 'custom'"
                         class="navadmin__delete"
                         [routerLink]="{ outlets: { 'modal': ['custom-delete', node.data.id] } }">
                        <i class="ico-remove"></i>
                      </a>
                    </ng-template>
                  </tree-root>
                </div>
                <br>
                <a class="cta cta--green cta--smaller"
                   [routerLink]="{ outlets: { 'modal': ['custom', lang] } }">
                  <span class="ico-plus"></span>
                  <span class="cta__light">Přidat</span> vlastní položku menu</a>
              </div>

              <div class="grid__cell grid__cell--nav">
                <h3 class="widget__heading">Položky využité v menu</h3>
                <div class="navadmin__list-wrap navadmin-selected">
                  <tree-root [nodes]="treeUsedNodes[lang]"
                             (moveNode)="onMoveNode($event, false)"
                             [options]="treeUsedOptions">
                    <ng-template #treeNodeTemplate
                                 let-node="node"
                                 let-index="index">
                      <i
                         [ngClass]="{'ico-pages': node.data.itemType === 'page', 'ico-box': node.data.itemType === 'category', 'ico-link': node.data.itemType === 'custom', 'ico-articles': node.data.itemType === 'blog', 'ico-real-estate': node.data.itemType === 'developer-projects', 'ico-homepage': node.data.itemType === 'real-estate'}"></i>
                      <span>{{ node.data.name }}
                        <span style="position: relative; left: 10px;">
                          <ui-switch color="#3dcb35"
                                     switchColor="#fff"
                                     [(ngModel)]="node.data.prominent"
                                     style="position: relative; top: -5px;">
                          </ui-switch>
                          <span class="switch__label__text"
                                style="float: none;">Zvýraznit</span>
                        </span>
                      </span>
                    </ng-template>
                  </tree-root>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="align-right">
          <a (click)="save()"
             class="cta cta--blue submit"
             [ngClass]="{'submit--submitting': isSaving}">
            <i class="ico-save"></i> Uložit</a>
        </div>

      </div>
      <div *ngIf="!isInitialized"
           class="widget__content loading"></div>
    </div>
  </div>
</div>
<router-outlet name="modal"></router-outlet>